/* Marie Bags (GL3c, B136): wagenlade en het maximum van 5 tassen per bestelling.
   - window.mbCart: add / change / refresh / open / capped, met sectierendering van cart-drawer en cart-icon-bubble.
   - Elk verzoek van welke code ook naar /cart/add, /cart/change of /cart/update dat het aantal tassen (regels die
     verzending vragen) boven het maximum brengt, wordt hier geweigerd met een 422 en de melding; Dawns formulieren
     tonen die melding zelf. Een wagen die toch te vol is (oude sessie, ander apparaat) wordt bij het laden
     teruggeknipt op de laatste tasregel, zoals de bron dat doet.
   - Dit is de themakant. De kassa dwingt het maximum af met de gewichtsvoorwaarde op het verzendtarief
     (verzendschema-voorstel.json); een Shopify Function voor kassavalidatie vraagt een app. */
(function () {
  'use strict';
  if (window.mbCart) return;
  var CFG = window.mbCapCfg || { max: 5, msg: "That's five, the most we can send to one home.", free: [] };
  var FREE = {};
  (CFG.free || []).forEach(function (id) { if (id) FREE[String(id)] = true; });
  var SECTIONS = 'cart-drawer,cart-icon-bubble';
  var origFetch = window.fetch.bind(window);
  var last = null;

  function units(cart) {
    return (cart && cart.items || []).reduce(function (n, i) { return n + (i.requires_shipping ? i.quantity : 0); }, 0);
  }
  function getCart() {
    return origFetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { last = c; return c; });
  }
  function emit(cart) {
    try { document.dispatchEvent(new CustomEvent('mb:cart', { detail: { cart: cart, units: units(cart), max: CFG.max } })); } catch (e) {}
  }
  function limitResponse() {
    var body = JSON.stringify({ status: 422, message: 'Cart Error', description: CFG.msg, errors: CFG.msg });
    return new Response(body, { status: 422, headers: { 'Content-Type': 'application/json' } });
  }
  function pathOf(input) {
    try { return new URL(typeof input === 'string' ? input : input.url, location.href).pathname; } catch (e) { return ''; }
  }

  // Lees de aanvraag, ongeacht of hij als JSON, FormData of URLSearchParams komt.
  function readBody(body) {
    if (body == null) return {};
    if (typeof body === 'string') {
      try { return JSON.parse(body); } catch (e) { body = new URLSearchParams(body); }
    }
    if ((window.FormData && body instanceof FormData) || (window.URLSearchParams && body instanceof URLSearchParams)) {
      var o = { items: [], updates: {} }, it = {};
      body.forEach(function (v, k) {
        var m = k.match(/^items\[(\d+)\]\[(id|quantity)\]$/);
        if (m) { it[m[1]] = it[m[1]] || {}; it[m[1]][m[2]] = v; return; }
        var u = k.match(/^updates\[(.+)\]$/);
        if (u) { o.updates[u[1]] = v; return; }
        if (k === 'updates[]') { (o.updatesArr = o.updatesArr || []).push(v); return; }
        if (k === 'id' || k === 'quantity' || k === 'line') o[k] = v;
      });
      Object.keys(it).forEach(function (k) { o.items.push(it[k]); });
      if (o.updatesArr) o.updates = o.updatesArr;
      return o;
    }
    return null;
  }

  // Aantal tassen na de aanvraag; null = niet te bepalen.
  function unitsAfter(kind, req, cart) {
    var now = units(cart), items = cart.items || [];
    function lineOf(ref, lineNo) {
      if (lineNo) return items[parseInt(lineNo, 10) - 1];
      return items.find(function (i) { return i.key === String(ref); }) || items.find(function (i) { return String(i.variant_id) === String(ref); });
    }
    if (kind === 'add') {
      var list = req.items && req.items.length ? req.items : (req.id ? [{ id: req.id, quantity: req.quantity }] : []);
      return now + list.reduce(function (n, i) {
        var inCart = items.find(function (x) { return String(x.variant_id) === String(i.id); });
        var ship = inCart ? inCart.requires_shipping : !FREE[String(i.id)];
        return n + (ship ? (parseInt(i.quantity, 10) || 1) : 0);
      }, 0);
    }
    if (kind === 'change') {
      var l = lineOf(req.id, req.line);
      if (!l) return null;
      return l.requires_shipping ? now - l.quantity + (parseInt(req.quantity, 10) || 0) : now;
    }
    if (kind === 'update') {
      var u = req.updates;
      if (!u) return now;
      var n = now;
      if (Array.isArray(u)) {
        u.forEach(function (q, k) { var x = items[k]; if (x && x.requires_shipping) n += (parseInt(q, 10) || 0) - x.quantity; });
      } else {
        Object.keys(u).forEach(function (ref) {
          var x = lineOf(ref);
          var q = parseInt(u[ref], 10) || 0;
          if (x) { if (x.requires_shipping) n += q - x.quantity; }
          else if (!FREE[String(ref)]) n += q;
        });
      }
      return n;
    }
    return null;
  }

  window.fetch = function (input, init) {
    var path = pathOf(input);
    var m = path.match(/\/cart\/(add|change|update)(?:\.js)?$/);
    if (!m || !(CFG.max > 0)) return origFetch(input, init);
    var req = readBody(init && init.body);
    if (!req) return origFetch(input, init);
    return getCart().then(function (cart) {
      var next = unitsAfter(m[1], req, cart);
      if (next !== null && next > CFG.max && next > units(cart)) {
        emit(cart);
        return limitResponse();
      }
      return origFetch(input, init).then(function (res) {
        setTimeout(afterChange, 0);
        return res;
      });
    }, function () { return origFetch(input, init); });
  };

  function drawer() { return document.querySelector('cart-drawer'); }

  // Zet de gerenderde secties in de pagina zonder de lade te openen.
  function apply(sections) {
    if (!sections) return;
    var d = drawer();
    var parser = new DOMParser();
    if (sections['cart-drawer']) {
      var doc = parser.parseFromString(sections['cart-drawer'], 'text/html');
      var src = doc.querySelector('#CartDrawer');
      var dst = document.getElementById('CartDrawer');
      if (src && dst) dst.innerHTML = src.innerHTML;
    }
    if (sections['cart-icon-bubble']) {
      var b = document.getElementById('cart-icon-bubble');
      var sd = parser.parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
      if (b && sd) b.innerHTML = sd.innerHTML;
    }
    if (d) {
      var inner = d.querySelector('[data-mb-cd]');
      var empty = !inner || inner.getAttribute('data-mb-count') === '0';
      d.classList.toggle('is-empty', empty);
      var ov = d.querySelector('#CartDrawer-Overlay');
      if (ov && !ov.__mb) { ov.__mb = true; ov.addEventListener('click', function () { d.close(); }); }
    }
  }

  function post(url, payload) {
    payload.sections = SECTIONS;
    payload.sections_url = location.pathname;
    return window.fetch(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) {
          var e = new Error(j.description || j.message || 'Something went wrong. Please try again.');
          e.status = r.status;
          throw e;
        }
        return j;
      });
    });
  }

  var busy = false;
  function setBusy(v) {
    busy = v;
    var inner = document.querySelector('[data-mb-cd]');
    if (inner) inner.classList.toggle('is-busy', v);
  }

  // De lade van gl3b (sections/mb-cart-drawer, window.jbCart) of Dawns <cart-drawer>: beide worden bediend.
  function jb() { return window.jbCart && typeof window.jbCart.open === 'function' ? window.jbCart : null; }

  function refresh() {
    if (jb()) {
      try { jb().refresh(); } catch (e) {}
      return getCart().then(function (c) { emit(c); return c; }).catch(function () {});
    }
    return origFetch(location.pathname + '?sections=' + SECTIONS, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (s) { apply(s); return getCart(); })
      .then(function (c) { emit(c); return c; })
      .catch(function () {});
  }

  function open() {
    if (jb()) { jb().open(); return; }
    var d = drawer();
    if (d && d.open) d.open();
  }

  function add(items, opts) {
    opts = opts || {};
    setBusy(true);
    return post('/cart/add.js', { items: items })
      .then(function (j) {
        apply(j.sections);
        if (opts.open !== false) open();
        else if (jb()) jb().refresh();
        return j;
      }, function (e) {
        if (e.status === 422) refresh();
        throw e;
      })
      .then(function (j) { setBusy(false); return j; }, function (e) { setBusy(false); throw e; });
  }

  function change(key, qty) {
    setBusy(true);
    return post('/cart/change.js', { id: key, quantity: qty })
      .then(function (j) { apply(j.sections); return j; }, function () { return refresh(); })
      .then(function (j) { setBusy(false); return j; });
  }

  // Wagen boven het maximum (buiten dit script om gevuld): knip de laatste tasregel terug.
  function clampToCap() {
    return getCart().then(function (cart) {
      var over = units(cart) - CFG.max;
      if (!(CFG.max > 0) || over <= 0) return null;
      var bags = (cart.items || []).filter(function (i) { return i.requires_shipping; });
      var l = bags[bags.length - 1];
      if (!l) return null;
      return origFetch('/cart/change.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: l.key, quantity: Math.max(0, l.quantity - over), sections: SECTIONS, sections_url: location.pathname })
      }).then(function (r) { return r.json(); }).then(function (j) {
        apply(j.sections);
        if (jb()) jb().refresh();
        return getCart().then(function (c) { emit(c); return over > (l.quantity) ? clampToCap() : c; });
      });
    }).catch(function () { return null; });
  }

  function afterChange() {
    getCart().then(function (c) {
      if (units(c) > CFG.max) return clampToCap();
      emit(c);
      return c;
    }).catch(function () {});
  }

  function onClick(e) {
    var inner = e.target.closest('[data-mb-cd]');
    if (!inner) return;
    var add_ = e.target.closest('[data-mb-cd-add]');
    if (add_) {
      e.preventDefault();
      if (busy || add_.disabled) return;
      add_.disabled = true;
      add(([{ id: parseInt(add_.getAttribute('data-mb-cd-add'), 10), quantity: 1 }]), { open: false })
        .catch(function () { add_.disabled = false; refresh(); });
      return;
    }
    var act = e.target.closest('[data-mb-cd-act]');
    if (!act) return;
    var row = act.closest('[data-mb-key]');
    if (!row || busy) return;
    var q = parseInt(row.getAttribute('data-mb-qty'), 10) || 1;
    var k = act.getAttribute('data-mb-cd-act');
    var next = k === 'rm' ? 0 : (k === 'inc' ? q + 1 : Math.max(0, q - 1));
    change(row.getAttribute('data-mb-key'), next);
  }

  function onChange(e) {
    var t = e.target.closest('[data-mb-cd-toggle]');
    if (!t) return;
    if (busy) { t.checked = !t.checked; return; }
    var card = t.closest('.mb-cd__card');
    var tx = card && card.querySelector('.mb-cd__picktx');
    if (tx) tx.textContent = t.checked ? 'Added' : 'Add';
    if (card) card.classList.toggle('is-on', t.checked);
    if (t.checked) {
      add([{ id: parseInt(t.getAttribute('data-mb-cd-toggle'), 10), quantity: 1 }], { open: false })
        .catch(function () { refresh(); });
    } else {
      var key = t.getAttribute('data-mb-key');
      if (key) change(key, 0); else refresh();
    }
  }

  // Maatcode in de lade zoals de bron ("L" in plaats van "(17 in x 16 in)"); gl3b's lade leest window.jbSizeLabel.
  var KNOWN = { '15x14': 'S', '17x16': 'L', '14x14': 'S', '16x16': 'L', '15x13.78': 'S', '16.93x15.75': 'L' };
  function sizeCode(part) {
    var v = String(part).toLowerCase();
    if (v.indexOf('small') > -1) return 'S';
    if (v.indexOf('medium') > -1) return 'M';
    if (v.indexOf('large') > -1) return 'L';
    if (v.indexOf('short') > -1) return 'Wide';
    if (v.indexOf('high') > -1) return 'Tall';
    var s = v.indexOf('/') > -1 && v.indexOf('cm') > -1 ? v.split('/').pop() : v;
    var m = s.match(/\d+(?:\.\d+)?/g);
    if (m && m.length >= 2 && KNOWN[m[0] + 'x' + m[1]]) return KNOWN[m[0] + 'x' + m[1]];
    return null;
  }
  if (!window.jbSizeLabel) {
    window.jbSizeLabel = function (title) {
      var t = String(title || '');
      if (/\(\d.*cm.*\)\/\(/.test(t)) return sizeCode(t) || t;
      var parts = t.split(' / ');
      var c = sizeCode(parts[0]);
      if (c) parts[0] = c;
      return parts.join(' / ');
    };
  }

  window.mbCart = {
    add: add,
    change: change,
    refresh: refresh,
    open: open,
    capped: function () { return !!last && units(last) >= CFG.max; },
    units: function () { return last ? units(last) : null; },
    max: CFG.max
  };

  function init() {
    document.addEventListener('click', onClick);
    document.addEventListener('change', onChange);
    document.addEventListener('keydown', function (e) {
      var d = drawer();
      if (e.key === 'Escape' && d && d.classList.contains('active') && d.close) d.close();
    });
    clampToCap().then(function (r) { if (!r) return getCart().then(emit); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
